export default "__VITE_ASSET__DibhTJNe__"